import React, { Component } from 'react';
import Slider from 'react-slick';
import { withStyles, Box } from '@material-ui/core';
import "../assets/styles/slick-artes.css"

const useStyles = theme => ({

});

class CarouselBrasil extends Component {
   render() {
      const settings = {
         className: "slider-video",
         centerMode: false,
         dots: true,
         arrows: false,
         infinite: true,
         centerPadding: "60px",
         slidesToShow: 1,
         speed: 500,
         responsive: [
            {
               breakpoint: 1024,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
               }
            },
            {
               breakpoint: 600,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true
               }
            },
            {
               breakpoint: 480,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true
               }
            }
         ]
      };
      return (
         <Slider {...settings}>
            <Box px={4}>
               <iframe src="https://drive.google.com/file/d/1d8vf0nMnX_Hpe-6cudDcHYx3Bp2NJLb3/preview" width="100%" title="Propaganda de Inauguração da Brasil Automóveis" frameborder="0" allow="autoplay"></iframe>
            </Box>
            <Box px={4}>
               <iframe src="https://drive.google.com/file/d/1G6OVPAtFXBvrIrPkrWxVlo0jBkbIJa63/preview" width="100%" title="Brasil Automóveis" frameborder="0" allow="autoplay"></iframe>
            </Box>
            <Box px={4}>
               <iframe src="https://drive.google.com/file/d/19B0OajiGTjqirfiKMve8_EDgJPje_nDA/preview" width="100%" title="Brasil Automóveis" frameborder="0" allow="autoplay"></iframe>
            </Box>
            <Box px={4}>
               <iframe src="https://drive.google.com/file/d/1afTmYI4aKlzRhGvcZ9-UheG5oRY2L01f/preview" width="100%" title="Brasil Automóveis" frameborder="0" allow="autoplay"></iframe>
            </Box>
         </Slider>
      );
   }
}
export default withStyles(useStyles)(CarouselBrasil);